// Sanitize user input: strip HTML tags and trim whitespace.
// Prevents XSS when values are rendered or stored.
export const sanitize = (input) => {
  if (typeof input !== 'string') return input;
  return input
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .trim();
};

// Sanitize but preserve the original characters (for DB storage).
// Strips actual HTML tags but keeps safe text.
export const stripTags = (input) => {
  if (typeof input !== 'string') return input;
  return input.replace(/<[^>]*>/g, '').trim();
};

// Validate email format
export const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

// Validate max length
export const maxLength = (input, max) => typeof input === 'string' && input.length <= max;
